// this store is for values whick are responsible for different display modes
import moment from 'moment'
import { uuid } from 'vue-uuid'

import { apiBase } from '@/utils/apiBase';
import { getGlobalDashboardIframe, postGlobalDashboardIframe } from '@/api/global-dashboard';

export default {
    namespaced: true,
    state: {
        loading: false,
        
        globalDashboards: [],

        offlineMaschines: [],
        
        charts: [],
        table: [],


        // show admin table
        maschinesAdminDashboard: [],


        iframeName: '',
        iframeURL: '',
        accessToken: '',
        iframeData: "{}",

        errorText: '',

        iframeWarning: {},

    },
    getters: {
       
        getOfflineMaschines(state) {
            return state.offlineMaschines
        },
        getGlobalDashboards(state){
            return state.globalDashboards
        },
        getTable(state){
            return state.table;
        },
        getCharts(state){
            return state.charts;
        },

        getLoading(state){
            return state.loading
        },

        getIframeName(state){
            return state.iframeName
        },

        getIframeURL(state){
            return state.iframeURL 
        },
        getIframeData(state){
            return state.iframeData
        },
        getIframeAccessToken(state){
            return state.accessToken
        },


        getShowAdminDashboard: (state) => state.maschinesAdminDashboard.length,
        maschinesAdminDashboard: (state) => state.maschinesAdminDashboard, 


      
    },
    mutations: {
       
        'set-offline-maschines': function(state, offlineMaschines){
            state.offlineMaschines = []
            offlineMaschines.forEach(oM => state.offlineMaschines.push(oM))
        },
        'set-global-dashboards': function(state, globalDashboards){
            
            state.globalDashboards = []

            // push function so VUE event change get triggered
            globalDashboards.forEach? globalDashboards.forEach(e => {
                e.key = uuid.v4();
                state.globalDashboards.push(e)
            }): '';
        },

        'set-table': function(state, table){
            //state.table = table;
            if(!table)
                return

            table.forEach(e => {

                e.key = uuid.v4()
                e.edit = false;

                e.unit = e.unit.join(', ')
                
            });
            state.table.splice(0, state.table.length, ...table)
        },
        'set-charts': function(state, charts){
            //state.table = table;
            if(!charts)
                return

            charts.forEach(e => {

                e.key = uuid.v4()
                e.edit = false;

                e.from = ''
                e.till = ''


                
            });
        
            state.charts.splice(0, state.charts.length, ...charts)
        },
        'set-loading': function(state, loading){
            state.loading = loading
        },


        'set-admin-dashboard-maschines': function(state, maschines){
            state.maschinesAdminDashboard = maschines
        },
        

        'clear-global-dashboard': function(state){
            state.charts.splice(0, 0, ...[])
            state.table.splice(0, 0, ...[])

            state.iframeURL = ''
            state.accessToken = ''

        },

        'set-iframe-name': function(state, value){
            state.iframeName = value
        },
        'set-iframe-url':function(state, url){
            state.iframeURL = url
        },
        'set-iframe-data':function(state, data){
            state.iframeData = data
        },
        'set-iframe-access-token':function(state, token){
            state.accessToken = token
        },

        'set-error-text': function(state, text){
            state.errorText = text;
        },
        'set-iframe-warning':function(state, text){
            state.iframeWarning = text
        }
    },
    actions: {
        'fetch-offline-maschines': async function({ commit, rootState }){
            const res = await fetch(`${apiBase()}/api/maschines/offline`, {method: 'POST', headers: { authorization: rootState.token }})
                        
            if(res.status == 200){

                const data = await res.json()
                
                // sort all maschines after offline date
                data.sort((a, b) => b.offlineDate - a.offlineDate)
                // convert dates into format
                data.forEach(e => e.offlineDate = moment.unix(e.offlineDate).format('YYYY-MM-DD HH:mm:ss') )
                commit('set-offline-maschines', data)
            }
            else{
                commit('set-offline-maschines', [])

                //console.error('Error fetching offline maschines', res.status);
            }
        },

        'get-global-dashboards': async function({rootState, commit}){
            
            const token = rootState.token;
            // 

            const res = await fetch(`${apiBase()}/api/global-dashboard`, { 
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": token
                }
            })
            // if status is ok set user variables
            if(res.status == 200){
                const body = await res.json()
                //console.log(body);
                
                commit('set-global-dashboards', body)
            }   
        },

        
        'fetch-global-dashboard-details': async function({commit, state, rootState}, globalDashboardId){

            commit('set-loading', true)
            commit('clear-global-dashboard')

            const isIframe = state.globalDashboards.some(e => e.id == globalDashboardId && e.type == 'iframe')
            
            if(isIframe){
                try{
                    const {globalDashboard, token} = await getGlobalDashboardIframe(globalDashboardId)
                    
                    commit('set-iframe-name', globalDashboard.name)
                    commit('set-iframe-url', globalDashboard.url)
                    commit('set-iframe-data', JSON.stringify(globalDashboard.data))

                    commit('set-iframe-access-token', token)

                }catch(e){
                    commit('set-error-text', 'Server Fehler')

                }
                
            }
            else{
                const token = rootState.token;

                const res = await fetch(`${apiBase()}/api/global-dashboard/${globalDashboardId}/details`, { 
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": token
                    }
                })
                // if status is ok set user variables
                if(res.status == 200){
                    const body = await res.json()
                    if(body.table)
                        commit('set-table', body.table)
                    else if(body.charts)
                        commit('set-charts', body.charts)

                }  
            }
             
            commit('set-loading', false)

            
        },

        'edit-global-dashboard-details-iframe': async function ({commit, state}, globalDashboardId) {
            //const data = {id: globalDashboardId, }
            try{
                
                const {globalDashboard, token, warning} = await postGlobalDashboardIframe(globalDashboardId,
                    { id:globalDashboardId,  name: state.iframeName }, // globalDashboard
                    { url: state.iframeURL, data:state.iframeData } // iframe
                )

                commit('set-iframe-name', globalDashboard.name)
                commit('set-iframe-url', globalDashboard.url)
                commit('set-iframe-data', JSON.stringify(globalDashboard.data))

                commit('set-iframe-access-token', token)


                commit('set-iframe-warning', warning)

                return ''
            }catch(e){
                commit('set-error-text', 'Server Fehler')
                throw new Error(e)
                
            }
            
        },


        'fetch-global-admin': async function ({commit, rootState}) {

            // commit, rootState
            const token = rootState.token;

            const res = await fetch(`${apiBase()}/api/maschines/admin-dashboard`, { 
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": token
                }
            })
            
            
            if(res.status == 200){
                const maschines = await res.json()
                
                commit('set-admin-dashboard-maschines', maschines);
            }else{
                commit('set-admin-dashboard-maschines', []);

            }

        },
    }
}